import React, {FC} from 'react';
import {Modal} from '../../modal';
import Button from '../../button';
import {closeIcon} from '../../../images/svgIcons';
import {HexomaticUserType} from '../../../helpers/contexts/hexomatic-user';
import {UserType} from '../../../helpers/contexts/user-context';
import {setHintPopupPerTool, toFixedNumber} from '../../../helpers';
import './styles.scss';

interface IProps {
  setLimit?: (val: string) => void;
  hideModal?: (val: boolean) => void;
  text?: string;
  defaultModal?: boolean;
  confirm?: () => void;
  automation_credits?: number;
  premium_credits?: number;
  hint_name?: string;
  user?: UserType | null;
  hexomaticUser?: HexomaticUserType | null;
}

const LimitReached: FC<IProps> = ({
  setLimit,
  text,
  defaultModal,
  hideModal,
  confirm,
  automation_credits,
  premium_credits,
  hint_name,
  user,
  hexomaticUser,
}) => {
  // const {hexomaticUser} = useContext(HexomaticUserContext);
  //const {user} = useContext(UserContext);
  const handleClose = () => {
    if (defaultModal && hint_name) {
      hideModal && hideModal(false);
      setHintPopupPerTool(hint_name, 'true');
      return;
    }
    setLimit && setLimit('');
  };

  const handleUpgrade = () => {
    if (!hexomaticUser || !hexomaticUser.premium_automation_credit || !hexomaticUser.automation_credit) return;
    hint_name && setHintPopupPerTool(hint_name, 'true');

    window.location.replace(
      premium_credits &&
        automation_credits &&
        premium_credits > +hexomaticUser.premium_automation_credit &&
        automation_credits <= +hexomaticUser.automation_credit
        ? 'https://dash.hexomatic.com/dashboard#modal_open'
        : 'https://hexomatic.com/pricing/',
    );
  };

  const handleClick = () => {
    if (defaultModal && hint_name) {
      setHintPopupPerTool(hint_name, 'true');
      hideModal && hideModal(false);
      confirm && confirm();
      return;
    }
    window.location.replace(
      text === 'Premium credits limit reached.'
        ? 'https://dash.hexomatic.com/dashboard#modal_open'
        : 'https://hexomatic.com/pricing/',
    );
  };
  return (
    <Modal
      isOpen={true}
      modalToggle={() => {}}
      modalFooter={<></>}
      className={`go-to-login-page ${premium_credits ? 'no-padding' : ''}`}
    >
      <div className="text-center">
        <div className="cursor-pointer text-right close-icon" onClick={handleClose}>
          {closeIcon}
        </div>
        {!defaultModal ? (
          <>
            <div className="mb-3">{text} </div>
            <div>
              <strong>Please upgrade your plan to continue</strong>
            </div>
          </>
        ) : (
          <div className="f_16">
            <div className="mb-3">
              Consumes <strong>{automation_credits}</strong> automation credit
              {automation_credits && automation_credits !== 1 ? 's' : ''}
              {premium_credits ? (
                <>
                  , <strong>{premium_credits}</strong> premium credit
                  {premium_credits && premium_credits !== 1 ? 's' : ''} {premium_credits > 0 ? 'per char' : ''}
                </>
              ) : (
                ''
              )}
              .
            </div>
            {user && hexomaticUser && (
              <>
                <div className="mb-1">
                  Automation credit balance:{' '}
                  <strong>
                    {/*@ts-ignore */}
                    {hexomaticUser.left_automation_credit && toFixedNumber(hexomaticUser.left_automation_credit)}
                  </strong>
                  .{' '}
                </div>
                <div className="mb-1">
                  Premium credit balance:{' '}
                  <strong>
                    {hexomaticUser &&
                      user &&
                      toFixedNumber(hexomaticUser.left_premium_automation_credit || 0 + user.left_premium_credits)}
                  </strong>
                  .{' '}
                </div>
                <div className="mb-0">
                  Need more credits?{' '}
                  <span className="clickable-text" onClick={handleUpgrade}>
                    Click here
                  </span>{' '}
                  to upgrade.
                </div>
              </>
            )}
          </div>
        )}
        <div className="mt-4 mb-3">
          <Button onClick={handleClick} className="w-md-75">
            {defaultModal ? 'OK' : 'Upgrade'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LimitReached;
